import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of transatel_mobile_recharges based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
  return baseIndex('transatel_data_recharges', page, itemPerPage, search, order, scheme);
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single transatel_mobile_recharge based on his ID
 *
 * @param id the of the transatel_mobile_recharge requested
 */
export function getFromId(id) {
  return baseGetFromId('transatel_data_recharges', id);
}

/**
 * Get a single transatel_mobile_recharge based on his ID
 *
 * @param id the of the transatel_mobile_recharge requested
 */
export function getIdentificationFromId(id) {
  return baseGetFromId('transatel_data_recharges', id, 'identification');
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single transatel_mobile_recharge based on his ID
 *
 * @param id the of the transatel_mobile_recharge requested
 * @param data the new data of the transatel_mobile_recharge
 */
export function editFromId(id, data) {
  return baseEditFromId('transatel_data_recharges', id, data);
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new transatel_mobile_recharge
 *
 * @param data the new data of the transatel_mobile_recharge
 */
export function newItem(data) {
  return baseNewItem('transatel_data_recharges', data);
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all transatel_mobile_recharges to serve in a dropdown form choice
 */
export function fetchTransatelDataRecharges(search) {
  return baseIndex('transatel_data_recharges', 1, 0, search, 'ASC');
}
